import { HeaderInfoService } from './../../../servicios/header-info.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { TablaGeneralComponent } from 'src/app/modulos/componentes-compartidos/tabla-general/tabla-general.component';

@Component({
  selector: 'app-pagina-usuarios',
  templateUrl: './pagina-usuarios.component.html',
  styleUrls: ['./pagina-usuarios.component.scss']
})
export class PaginaUsuariosComponent implements OnInit {
  @ViewChild(TablaGeneralComponent) tablaGeneral: TablaGeneralComponent;
  unidadId: number = 0;
  public usuarioSeleccionado: any = null;

  public displayedColumns: any[] = [
    {
      nombre: 'nombreUsuario',
      titulo: 'Nombre',
      valueFieldName: 'us_nombres'
    },
    {
      nombre: 'apellidoUsuario',
      titulo: 'Apellido',
      valueFieldName: 'us_apellidos'
    },
    {
      nombre: 'documento',
      titulo: 'No. de identidad',
      valueFieldName: 'us_numero_documento'
    },
    {
      nombre: 'correo',
      titulo: 'Correo',
      valueFieldName: 'us_correo'
    },
    {
      nombre: 'telefono',
      titulo: 'Teléfono',
      valueFieldName: 'us_celular'
    },
    {
      nombre: 'lugar',
      titulo: 'Lugar Asignado',
      valueFieldName: 'lugar_render'
    },
    {
      nombre: 'estadoEnvio',
      titulo: 'Estado Correo',
      valueFieldName: 'estado_legible'
    }
  ];

  constructor(
    private headerInfoService: HeaderInfoService
  ) {
    const dataString = localStorage.getItem('data_login');
    if (dataString) {
      try {
        const data_login = JSON.parse(dataString);
        this.unidadId = data_login?.company_id || 0;
      } catch (e) {
        this.unidadId = 0;
      }
    }
  }

  ngOnInit() {
    this.headerInfoService.cambiarTituloPagina("USUARIOS");
    this.headerInfoService.cambiarTituloTarjeta("¡Bienvenido a usuarios!");
    this.headerInfoService.cambiarTextoTarjeta("Aquí puedes visualizar y gestionar todos los usuarios registrados en el sistema.");
  }

  public abrirModalEditar(usuario: any): void {
    this.usuarioSeleccionado = usuario;
  }

  public cerrarModal(): void {
    this.usuarioSeleccionado = null;
  }

  public onUsuarioActualizado(): void {
    this.cerrarModal();
    if (this.tablaGeneral) {
      this.tablaGeneral.cargarDatosUsuarios();
    }
  }
}
